import { render, staticRenderFns } from "./ProfitMargins.vue?vue&type=template&id=163cec0a&scoped=true"
import script from "./ProfitMargins.vue?vue&type=script&lang=js"
export * from "./ProfitMargins.vue?vue&type=script&lang=js"
import style0 from "./ProfitMargins.vue?vue&type=style&index=0&id=163cec0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163cec0a",
  null
  
)

export default component.exports